export default __webpack_public_path__ + "static/media/thumbnail.16fcbcf1.png";